// CommentService (§17). Komentáře tématu, volitelně s odkazem na viewpoint —
// tím vzniká vizuální historie řešení problému.
import { createComment, nowISO } from "../core/model.js";
import { pushAudit } from "../core/audit.js";

export class CommentService {
  constructor({ topicService, repository, events, currentUser }) {
    this.topicService = topicService;
    this.repository = repository;
    this.events = events;
    this.currentUser = currentUser || (() => null);
  }
  _user() { const u = this.currentUser(); return (u && u.id) || u || null; }

  async addComment(topicId, data = {}) {
    const topic = this.topicService.getTopic(topicId);
    if (!topic) throw new Error("Téma nenalezeno: " + topicId);
    const comment = createComment({ ...data, author: data.author || this._user() });
    topic.comments.push(comment);
    pushAudit(topic, { userId: this._user(), action: "Comment added", after: { commentId: comment.id } });
    if (this.repository) await this.repository.saveTopic(topic);
    this.events && this.events.emit("bcf.comment.created", { topicId, comment });
    return comment;
  }

  listComments(topicId) {
    const topic = this.topicService.getTopic(topicId);
    return topic ? topic.comments.slice() : [];
  }

  async editComment(topicId, commentId, text) {
    const topic = this.topicService.getTopic(topicId);
    if (!topic) throw new Error("Téma nenalezeno: " + topicId);
    const c = topic.comments.find((x) => x.id === commentId);
    if (!c) throw new Error("Komentář nenalezen: " + commentId);
    c.text = text;
    c.modifiedAuthor = this._user();
    c.modifiedDate = nowISO();
    if (this.repository) await this.repository.saveTopic(topic);
    this.events && this.events.emit("bcf.comment.updated", { topicId, comment: c });
    return c;
  }

  async deleteComment(topicId, commentId) {
    const topic = this.topicService.getTopic(topicId);
    if (!topic) return false;
    const idx = topic.comments.findIndex((x) => x.id === commentId);
    if (idx < 0) return false;
    topic.comments.splice(idx, 1);
    if (this.repository) await this.repository.saveTopic(topic);
    this.events && this.events.emit("bcf.comment.deleted", { topicId, commentId });
    return true;
  }
}
